import { getRequest, postRequest, getcontractIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`

  return getRequest(
    `interval/get-list/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`interval/edit/${id}`)
}

export async function save(values) {
  return postRequest(`interval/save`, values)
}

export function remove(values) {
  return postRequest(`interval/delete`, values)
}
